import { render, staticRenderFns } from "./commande_transferer.vue?vue&type=template&id=d4f0bc38&"
import script from "./commande_transferer.vue?vue&type=script&lang=js&"
export * from "./commande_transferer.vue?vue&type=script&lang=js&"
import style0 from "./commande_transferer.vue?vue&type=style&index=0&id=d4f0bc38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports